export const isParlayCard = (componentId: number): boolean => {
    return componentId === 210;
};
